import React from "react";
import { ErrorMessage, useFormikContext } from "formik";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import { convertTextToTitleCase } from "../../CommonFuntion/SchemaValidation";

import { titleCase } from "../../CommonFuntion/SchemaValidation";
const CssTextField = styled(TextField)({});
export function BarCode(props) {
  const { name, label, tagName, validation, prefix, size, calculation, type } =
    props;
  const { setFieldValue } = useFormikContext();

  const handleChange = (e) => {
    const { value } = e.target;
    setFieldValue([name], value);
    if (validation.characterCase) {
      switch (validation.characterCase) {
        case "U":
          setFieldValue([name], value.toUpperCase());
          break;
        case "L":
          setFieldValue([name], value.toLowerCase());
          break;
        case "C":
          setFieldValue([name], convertTextToTitleCase(value));
          break;
        default:
          setFieldValue([name], value);
          break;
      }
    }
  };
  var strCharactersText;
  var strHelpText;
  if (
    calculation === "3" ||
    type === "4" ||
    type === "5" ||
    type === "8" ||
    type === "9"
  )
    strCharactersText = "No. Characters: " + size;
  else strCharactersText = "Max. Characters: " + size;

  switch (type) {
    case "0":
      strHelpText =
        "Code 39 - Full ASCII, " +
        strCharactersText +
        ", Valid characters: Alphanumeric '-', '.', ' ', '%', '$', '/', '+'";
      break;
    case "1":
      strHelpText =
        "Code 39 - Normal, " +
        strCharactersText +
        ", Valid characters: Alphanumeric '-', '.', ' ', '%', '$', '/', '+'";
      break;
    case "2":
      strHelpText =
        "Code 93, " +
        strCharactersText +
        ", Valid characters: Alphanumeric '-', '.', ' ', '%', '$', '/', '+', '(', ')'";
      break;

    case "3":
      strHelpText =
        "Code 128, " + strCharactersText + ", Valid characters: All Characters";
      break;

    case "4":
      strHelpText =
        "EAN-8, " + strCharactersText + ", Valid characters: Numeric";
      break;
    case "5":
      strHelpText =
        "EAN-13, " + strCharactersText + ", Valid characters: Numeric";
      break;
    case "6":
      strHelpText =
        "EAN/UPC 128, " +
        strCharactersText +
        ", Valid characters: All Characters";
      break;
    case "7":
      strHelpText =
        "Interleaved 2 of 5, " +
        strCharactersText +
        ", Numeric: All Characters";
      break;
    case "8":
      strHelpText =
        "UPC-A, " + strCharactersText + ", Valid characters: Numeric";
      break;
    case "9":
      strHelpText =
        "UPC-E, " + strCharactersText + ", Valid characters: Numeric";
      break;
    default:
      break;
  }
  switch (calculation) {
    case "0":
      strHelpText = strHelpText + ", Check digit: Validated";
      break;
    case "1":
      strHelpText = strHelpText + ", Check digit: Calculated";
      break;
    case "2":
      strHelpText = strHelpText + ", Check digit: Ignore";
      break;

    case "3":
      strHelpText = strHelpText + ", Check digit: Override";
      break;
    default:
      break;
  }
  return (
    <>
      <div className="flex-container">
        <div className="control-bottom-border">
          {label && (
            <label className="font-css">
              {titleCase(label.replace("_", " "))}
              {validation?.mandatory && (
                <span className="mandatory-validation">{"*"}</span>
              )}
            </label>
          )}
        </div>

        <div className="control-bottom-border">
          <FormControl>
            <Tooltip
              title={
                strHelpText +
                (validation && validation.pictureMask
                  ? "\nPicture Mask:" + validation.pictureMask
                  : "") +
                (validation && validation.mandatory ? "\nMandatory" : "")
              }
            >
              <CssTextField
                id={tagName}
                inputProps={{
                  maxLength: size ? size : "",
                }}
                type="text"
                name={name}
                key={name}
                tagname={tagName}
                prefix={prefix}
                placeholder=""
                onChange={handleChange}
                variant="standard"
                style={{
                  fontSize: "12px",
                  width: "200px",
                }}
              />
            </Tooltip>
          </FormControl>

          <ErrorMessage
            name={name}
            render={(msg) => {
              return <div className="is-invalid">{msg}</div>;
            }}
          />
        </div>
      </div>
    </>
  );
}
